import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CategoryModule } from '../category/category.module';

@NgModule({
  imports: [CommonModule, CategoryModule],
})
export class AreaOfUseModule {}
